import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/images/icon-upload.svg'
import _imports_1 from '@/assets/images/icon-trash.svg'


const _hoisted_1 = { class: "upload u-mar-b-2" }
const _hoisted_2 = {
  key: 0,
  class: "ueberschrift"
}
const _hoisted_3 = {
  key: 0,
  class: "ueberschriftDownloadLink"
}
const _hoisted_4 = ["href"]
const _hoisted_5 = {
  key: 1,
  class: "o-grid drop"
}
const _hoisted_6 = { class: "o-grid__cell o-grid__cell--2 action" }
const _hoisted_7 = {
  class: "add",
  title: "Datei hinzufügen"
}
const _hoisted_8 = ["accept", "multiple"]
const _hoisted_9 = {
  key: 2,
  class: "gevng-form-validation__error-container"
}
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = {
  key: 0,
  class: "o-grid list"
}
const _hoisted_12 = { class: "o-grid__cell o-grid__cell--10 filename" }
const _hoisted_13 = {
  key: 0,
  class: "gevng-form-validation__error-container",
  style: {"margin-bottom":"10px"}
}
const _hoisted_14 = { class: "o-grid__cell o-grid__cell--2 action" }
const _hoisted_15 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.$props?.ueberschrift)
      ? (_openBlock(), _createElementBlock("h3", _hoisted_2, [
          _createTextVNode(_toDisplayString(_ctx.$props.ueberschrift) + " ", 1),
          (_ctx.$props?.ueberschriftDownloadLink)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                _createElementVNode("a", {
                  href: _ctx.$props.ueberschriftDownloadLink,
                  target: "_blank"
                }, "herunterladen", 8, _hoisted_4)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.$props?.fileCount && _ctx.$props.fileCount > _ctx.currentFileCount)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "o-grid__cell o-grid__cell--10" }, null, -1)),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("label", {
                for: "dateidialog",
                onClick: _cache[0] || (_cache[0] = ($event: any) => ((_ctx.$refs['dateidialog'] as any).click())),
                onKeydown: [
                  _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event: any) => ((_ctx.$refs['dateidialog'] as any).click()), ["prevent"]), ["enter"])),
                  _cache[2] || (_cache[2] = _withKeys(_withModifiers(($event: any) => ((_ctx.$refs['dateidialog'] as any).click()), ["prevent"]), ["space"]))
                ]
              }, _cache[6] || (_cache[6] = [
                _createElementVNode("img", {
                  src: _imports_0,
                  alt: "Hochladen",
                  title: "Klicken, um eine Datei auszuwählen",
                  class: "icon"
                }, null, -1)
              ]), 32),
              _createElementVNode("input", {
                id: "dateidialog",
                ref: "dateidialog",
                accept: _ctx.$props.extensions ? _ctx.$props.extensions : '*',
                multiple: _ctx.$props.fileCount > 1,
                type: "file",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.vermeideDoppeldialog($event))),
                onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.dateiauswahlVerarbeiten($event, _ctx.$props.dokumentart, _ctx.$props.id))),
                onInput: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onInput && _ctx.onInput(...args))),
                style: {"display":"none"}
              }, null, 40, _hoisted_8)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.fehlerListe)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fehlerListe, (fehler) => {
            return (_openBlock(), _createElementBlock("div", {
              key: fehler,
              innerHTML: fehler
            }, null, 8, _hoisted_10))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.piniaStore.state.dateien, (file, index) => {
      return (_openBlock(), _createElementBlock(_Fragment, {
        key: file.id
      }, [
        (file.gruppe === _ctx.$props.id)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createTextVNode(_toDisplayString(file.name) + " ", 1),
                (file.state == 'error')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, " Datei konnte nicht hochgeladen werden - bitte probieren Sie es erneut. "))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", {
                  onClick: ($event: any) => (_ctx.deleteFile(index, file.id)),
                  class: "delete",
                  title: "Datei löschen"
                }, _cache[8] || (_cache[8] = [
                  _createElementVNode("img", {
                    src: _imports_1,
                    alt: "Löschen",
                    title: "Klicken, um eine Datei zu löschen",
                    class: "icon"
                  }, null, -1)
                ]), 8, _hoisted_15)
              ])
            ]))
          : _createCommentVNode("", true)
      ], 64))
    }), 128))
  ]))
}